import React, { useEffect, useState } from "react";
import "./NavMenu.scss";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { links } from "../../../../../utils/config";
import { useDisabledScroll } from "../../../../../hooks/useDisabledScroll";
import { useAppSelector } from "../../../../../redux/hooks";
import { ILink, ISubLink, PropsNavMenu } from "../../../../../types";
import cx from "classnames";
import { useWindowResize } from "../../../../../hooks/useWindowResize";

const NavMenu: React.FC<PropsNavMenu> = ({ handlerOpenAndCloseBurgerMenu, openBurgerMenu }) => {
  const { handlerDisabledScroll } = useDisabledScroll;
  const { packetInBasket } = useAppSelector((state) => state.packets);
  const { auth, user } = useAppSelector((state) => state.user);
  const isAdmin = auth && user.role.includes("ADMIN");
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { width } = useWindowResize();
  const [expandedMenus, setExpandedMenus] = useState<string[]>([]);

  useEffect(() => {
    handlerDisabledScroll(openBurgerMenu);
    if (!openBurgerMenu) setExpandedMenus([]);

    return () => handlerDisabledScroll(false);
  }, [handlerDisabledScroll, openBurgerMenu]);

  //Обработчик клика по ссылке подменю
  const handleClickDropdownLink = (): void => {
    if (width <= 1279) {
      handlerOpenAndCloseBurgerMenu();
    }
  };

  //Обработчик клика по ссылке меню
  const handleClickLink = (): void => {
    if (width <= 1279) {
      handlerOpenAndCloseBurgerMenu();
    }
  };

  //Обработчик клика по корзине
  const handleClickFromBasket = (event: React.MouseEvent): void => {
    if (packetInBasket.length) {
      navigate("/basket");
      if (width <= 1279) {
        handlerOpenAndCloseBurgerMenu();
      }
    }
    event.stopPropagation();
  };

  // const pathHiddenMenu = ["/aboutMe/", "/contact/", "/photo-products"];

  // Обработчик раскрытия категорий Gallery и Investment
  const handleToggleSubmenu = (linkActive: ILink): void => {
    const linkName = linkActive.name;
    if (!linkName) return;

    setExpandedMenus((current) =>
      current.includes(linkName) ? current.filter((name) => name !== linkName) : [...current, linkName]
    );
  };

  return (
    <nav
      id="main-navigation"
      aria-label="Main navigation"
      className={`navigation ${openBurgerMenu ? "navigation__burgerMenu_active" : ""}`}
      onClick={handlerOpenAndCloseBurgerMenu}
    >
      <ul
        className="navigation__list_links"
        onClick={(event: React.MouseEvent<HTMLUListElement>) => event.stopPropagation()}
      >
        {links.map((item: ILink) => {
          const isExpanded = Boolean(item.name && expandedMenus.includes(item.name));
          const isParentActive = Boolean(
            item.select?.some(({ pathSelect }) => pathname.startsWith(pathSelect.replace(/\/$/, "")))
          );
          const submenuId = item.name ? `navigation-${item.name.toLowerCase()}-submenu` : undefined;

          return (
            <li className="navigation__container-link navigation__view-lists-links" key={item.name}>
              {item.select ? (
                <button
                  type="button"
                  className={cx(
                    "navigation__link",
                    "navigation__link-arrow",
                    isParentActive && "navigation__link_active",
                    isExpanded && "subLinks__active"
                  )}
                  onClick={() => handleToggleSubmenu(item)}
                  aria-expanded={isExpanded}
                  aria-controls={submenuId}
                >
                  <span> {item.name}</span>
                </button>
              ) : (
                <NavLink
                  className={({ isActive }) =>
                    cx(
                      "navigation__link",
                      `navigation__link_${isActive ? "active" : ""}`,
                      item.select ? "navigation__link-arrow" : ""
                    )
                  }
                  end
                  to={item.path ? item.path : ""}
                  title={item.name}
                  onClick={handleClickLink}
                >
                  {item.name}
                </NavLink>
              )}
              {item.select && (
                <div
                  id={submenuId}
                  className={cx(
                    "navigation__subLinks-container",
                    "navigation__view-lists-links_active",
                    isExpanded && "navigation__subLinks-container_active"
                  )}
                >
                  {Array.isArray(item.select) &&
                    item.select.map((el: ISubLink) => {
                      return (
                        <NavLink
                          className={({ isActive }) =>
                            cx("navigation__sublink", `navigation__sublink${isActive ? "_active" : ""}`)
                          }
                          to={el.pathSelect}
                          key={el.name}
                          onClick={handleClickDropdownLink}
                          title={el.title}
                        >
                          {el.name}
                        </NavLink>
                      );
                    })}
                </div>
              )}
            </li>
          );
        })}
        {isAdmin && (
          <li className="navigation__container-link">
            <Link className="navigation__adminPanel" to="/admin/" onClick={handleClickLink}>
              Admin-panel
            </Link>
          </li>
        )}
        <li className="navigation__container-link">
          {!isAdmin && (
            <div className="navigation__basketMenuItem" onClick={handleClickFromBasket}>
              <div className="navigation__basket navigation__tooltip">
                {packetInBasket.length > 0 ? (
                  <span className="navigation__basket_notEmpty ">{packetInBasket.length}</span>
                ) : (
                  <div className="navigation__basketTooltip navigation__tooltip_active">Your cart is empty</div>
                )}
              </div>
              <span className="navigation__basketLabel">Cart</span>
            </div>
          )}
        </li>
      </ul>
    </nav>
  );
};

export default NavMenu;
